import { styled } from "@linaria/react"
import { Link } from "@tanstack/react-router"

import { useOrgHomeLocation } from "@/hooks/useMatterLocation.ts"
import { Navigator } from "@/routes/Navigator.ts"
import { focusOutline } from "@/styles/mixins.ts"

import LogoImage from "./logo.svg?react"


export const Logo = (props: {
  orgPage?: boolean
}) => {
  if (props.orgPage === false) {
    return (
      <LogoLink {...Navigator.home()} viewTransition>
        <MatterLogo />
      </LogoLink>
    )
  }

  return <OrgLogo />
}

const OrgLogo = () => {
  const location = useOrgHomeLocation()

  return (
    <LogoLink data-testid="organization-logo" {...location} viewTransition>
      <MatterLogo />
    </LogoLink>
  )
}

export const MatterLogo = () => {
  return <LogoImage />
}

const LogoLink = styled(Link)`
  display: flex;

  &:focus-visible {
    ${focusOutline};
  }
`
